const TECHNICAL_ERROR_CODES: Record<string, string> = {};

const FUNCTIONAL_ERROR_CODES: Record<string, string> = {};

export const getErrorDescription = (errorType: string, errorCode: string): string => {
  if (errorType === 'technical') {
    return TECHNICAL_ERROR_CODES[errorCode] || 'N/A';
  }

  if (errorType === 'functional') {
    return FUNCTIONAL_ERROR_CODES[errorCode] || 'N/A';
  }

  return 'N/A';
};
